module.exports = __webpack_public_path__ + "img/collector.8bd51c99.png";